import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';
import { redirectTo } from "../../../../core/utils";

export class FantasyCoachView extends View {
	get template() {
		return template;
	}
	get className() {
		return "fantasy-coach-page";
	}

	regions() {
		return {
			advert: '.advert'
		};
	}

	ui() {
		return {
			'next': '.js-show-game-selector'
		}
	}

	events() {
		return {
			'click @ui.next': 'showGameSelector',
		};
	}

	showGameSelector() {
		redirectTo('game-selector');
	}
}

export default FantasyCoachView;